import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function huodongAdd (data) {
  return request({
    url: baseURL + 'huodong/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function huodongList (data) {
  return request({
    url: baseURL + 'huodong/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function huodongDelete (data) {
  return request({
    url: baseURL + 'huodong/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function huodongUpdate (data) {
  return request({
    url: baseURL + 'huodong/update',
    method: 'post',
    data: data
  })
}

//  信息查询
export function huodongRecordList (data) {
  return request({
    url: baseURL + 'huodongRecord/list',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/huodong/index.js